// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { formatDate } from '../../../utils/formatCalendar';

export default class UrlCallbacksPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'urlCallbacks';
        this.Server = this.props.context.getState().server.urlCallbacks;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'url', 'request', 'response'];
        this.dateRangeField = 'createdAt';

        this.hasCustomLogicOnMount = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'uuid',
                    label: 'uuid',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'url',
                    label: 'url',
                    alignRight: false,
                    cell: 'Url',
                    displayGrid: true
                },
                {
                    id: 'signature',
                    label: 'signature',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'request',
                    label: 'request',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json',
                    disableEditor: true
                },
                {
                    id: 'response',
                    label: 'response',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json',
                    disableEditor: true
                },
                {
                    id: 'status',
                    label: 'status',
                    alignRight: false,
                    cell: 'State',
                    items: ['retry', 'success', 'fail'],
                    displayGrid: true
                },
                {
                    id: 'executionTime',
                    label: 'executionTime',
                    alignRight: false,
                    cell: 'Time', // TODO: Create Time cell
                    displayGrid: true
                },
                {
                    id: 'history',
                    label: 'history',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json',
                    disableEditor: true
                },
                {
                    id: 'retriesRemaining',
                    label: 'retriesRemaining',
                    alignRight: false,
                    cell: 'Number',
                    type: 'number',
                    displayGrid: true
                },
                {
                    id: 'nextRetry',
                    label: 'nextRetry',
                    alignRight: false,
                    cell: 'Date',
                    disableEditor: true,
                    displayGrid: true
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['createdAt', 'updatedAt'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'createdAt',
                },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    customLogicOnMount = () => {
        const endDate = new Date();
        const startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        const lastWeek = formatDate(startDate, endDate);
        this.dateRangeSave(lastWeek);

    };

    renderCustomMenuItems() {
        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>
        ];
    }
}
